import React from "react";
import { Mail, MessageSquare } from "lucide-react";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import type { ChannelType } from "@/types/inbox";

const CHANNEL_LABELS: Record<ChannelType, string> = {
	email: "Email",
	linkedin: "LinkedIn",
	whatsapp: "WhatsApp",
	other: "Chat",
};

export function channelLabel(channel: ChannelType): string {
	return CHANNEL_LABELS[channel];
}

export const ChannelIcon: React.FC<{ channel: ChannelType; className?: string }> = ({
	channel,
	className,
}) => {
	const iconClass = cn("h-3.5 w-3.5", className);
	switch (channel) {
		case "email":
			return <Mail className={iconClass} aria-hidden />;
		case "linkedin":
			return <FaLinkedinIn className={iconClass} aria-hidden />;
		case "whatsapp":
			return <FaWhatsapp className={iconClass} aria-hidden />;
		default:
			return <MessageSquare className={iconClass} aria-hidden />;
	}
};

/** Small channel chip used in the thread header and context panel. */
export const ChannelBadge: React.FC<{ channel: ChannelType; className?: string }> = ({
	channel,
	className,
}) => (
	<Badge variant="secondary" className={cn("gap-1 font-normal text-muted-foreground", className)}>
		<ChannelIcon channel={channel} className="h-3 w-3" />
		{channelLabel(channel)}
	</Badge>
);
